import * as React from "react";

function SvgHeaderCityArrow(props) {
  return <svg width={6} height={3} viewBox="0 0 6 3" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3.283 2.717L5.317.683A.4.4 0 005.034 0H.966a.4.4 0 00-.283.683l2.034 2.034a.4.4 0 00.566 0z" fill="#FFF" fillRule="evenodd" /></svg>;
}

export default SvgHeaderCityArrow;